module.exports = __webpack_public_path__ + "img/port2.f5e3af07.png";